/* eslint-disable no-unused-vars */
import React from "react";
import PrivacyPopup from "../PrivacyPopup/PrivacyPopup";
import { Switch } from "react-router-dom";

const layout = (props) => {
  return (
    <div className="wrapper">
      <main>{props.children}</main>
      <PrivacyPopup />
    </div>
  );
};
export default layout;
